import dayjs from "dayjs";
import FileSaver from "file-saver";
import apiClient from "../../../apis/tenant-management/tenant-management-client";
import { BaseApplicationService } from "../../../domain/base/base-application-service";
import { reportAsyncError } from "../../../../error-reporter";
import { userAuditLogOldestAvailableDate } from "../../../domain/audit/user-audit-log";

export type UserAuditLogContextProps = {
  isLoading: boolean;
  dateRange: { from?: Date; to?: Date };
  setFilterCondition: typeof UserAuditService.prototype.setFilterCondition;
  downloadCSV: typeof UserAuditService.prototype.downloadCSV;
};

export class UserAuditService extends BaseApplicationService<UserAuditLogContextProps> {
  state = {
    isLoading: false,
    dateRange: {
      from: userAuditLogOldestAvailableDate(),
      to: dayjs().toDate(),
    },
    setFilterCondition: this.setFilterCondition.bind(this),
    downloadCSV: this.downloadCSV.bind(this),
  };

  setFilterCondition(filter: { dateRange: { from?: Date; to?: Date } }) {
    this.setState({
      dateRange: filter.dateRange,
    });
  }

  async downloadCSV() {
    this.setState({ isLoading: true });
    try {
      const { data } = await apiClient.downloadUserAuditCsv({
        ...this.state.dateRange,
      });
      FileSaver.saveAs(
        new Blob([data]),
        `ユーザー監査ログ_${new Date().toDateString()}.csv`,
      );
    } catch (e) {
      reportAsyncError(e);
    } finally {
      this.setState({ isLoading: false });
    }
  }
}
